import React from 'react';
import classnames from 'classnames';

import s from './WidgetHeaderWide.scss';

export interface Props {
  header: string | React.ReactNode;
  extras?: React.ReactNode | React.ReactNode[];
  subHeader?: string;
  className?: string;
}

export class WidgetHeaderWide extends React.Component<Props> {
  render() {
    const { className, header, subHeader, extras } = this.props;
    return (
      <div className={classnames(s['root'], className)}>
        <h3 className={s['header']}>{header}</h3>
        {subHeader && <div className={s['sub-header']}>{subHeader}</div>}
        {extras}
      </div>
    );
  }
}

export default WidgetHeaderWide;
